import { useEffect } from "react";
import { useQuery } from "~hooks/useQuery";
import {
  EventAccessStatus,
  GetEventAndReleaseForCustomerDocument,
} from "~graphql/typed-document-nodes";
import { getError, showToast } from "~lib";
import { useRouter } from "next/router";
import { ToastType } from "react-toastify";

type QueryParams = {
  eventId?: string;
  release?: string;
  slug?: string;
};

export const useEventAccessControl = (userEventId?: string) => {
  const router = useRouter();

  const query = router.query as QueryParams;

  const eventId = query.eventId ?? userEventId;
  const releaseId = query.release;

  const { isLoading, data, error, isValidating } = useQuery(
    eventId ? GetEventAndReleaseForCustomerDocument : null,
    {
      input: { eventId, releaseId, releaseSlug: query.slug },
    }
  );

  const { event, release, isAdmin, accessType } =
    data?.getEventAndReleaseForCustomer ?? {};

  useEffect(() => {
    if (!eventId) return;

    if (getError(error, "graphQL") === EventAccessStatus.Denied) {
      void router.push("/");
      void showToast(
        "This event is not public. Admin only access.",
        ToastType.ERROR
      );
    }
    if (getError(error, "graphQL") === EventAccessStatus.EventEnded) {
      void router.push("/");
      void showToast("This event has finished.", ToastType.ERROR);
    }
  }, [eventId, error]);

  return {
    isLoading,
    release,
    isAdmin,
    event,
    error,
    isValidating,
    accessType,
  };
};
